import React, { useState, useEffect } from 'react';
import SideMenu from '../side_menu/side_menu';
import './header.css';
import './hamburguer.css'
import LanguageSelector from '../language_handler/language_selector';
import { useTranslation } from 'react-i18next';
import ImageInfo from '../tools/image_info'

const Header = ({ selectedPage, setSelectedPage }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const { t, i18n } = useTranslation('header');

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        const handleScroll = () => { // Check if the page is scrolled more than 50px (adjust this value as needed)
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll); // Attach the event listener

        return () => {  // this is called when the component is removed, so we avoid memory leaks
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
                <div className={`header__logo ${isScrolled ? 'header__logo--scrolled' : ''}`}>
                    <img src={`${process.env.PUBLIC_URL}/images/Imagen-1.-logo-con-letras.jpg`} alt="logo" />
                </div>

                <div className={`header__info`}>
                    <ImageInfo imageUrl={`${process.env.PUBLIC_URL}/images/ubicacion.png`} lines={["FUENGIROLA - C/ BLANCA PALOMA 7, LOCAL 2", "MÁLAGA – C/ FERNANDO CAMINO 11, 1 A"]}/>
                    <ImageInfo imageUrl={`${process.env.PUBLIC_URL}/images/horario.png`} lines={["FUENGIROLA – L, X, J - 10:00 A 17:00", "MÁLAGA – M, V - 09:30 A 13:30 "]}/>
                    <ImageInfo imageUrl={`${process.env.PUBLIC_URL}/images/telefono.png`} lines={["952 46 16 69 - 695 58 32 40", "ATENCIÓN TELEFÓNICA"]}/>
                </div>

                <div className="header__menu-btn hamburguer-btn" onClick={toggleMenu}>
                     <div className="hamburguer-btn__slice"></div>
                     <div className="hamburguer-btn__slice"></div>
                     <div className="hamburguer-btn__slice"></div>
                </div>

                <div className="header__nav">
                    <span className="header__link" onClick={() => setSelectedPage(1)}>{t('inicio')}</span> {/* if not its called on render */ }
                    <span className="header__link" onClick={() => setSelectedPage(2)}>{t('sobre_nosotros')}</span>
                    <span className="header__link" onClick={() => setSelectedPage(3)}>{t('centro_quiropractiro')}</span>
                    <span className="header__link" onClick={() => setSelectedPage(4)}>{t('dosier_cientifico')}</span>
                </div>

                <LanguageSelector className="header__language" />
            </header>

            <SideMenu isOpen={isMenuOpen} onClose={toggleMenu} setSelectedPage={setSelectedPage} />
        </>
    );
};

export default Header;
